export default __webpack_public_path__ + "static/media/screen.6ba80223.svg";